import { t } from 'i18next';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';

import { EventLogClass, EventLogLabel, EventLogName, EventLogNameDis, EventLogSource, TicketUndeliveredLabel } from '../../../../../utils/common/constants';
import { formatEventLogDetails, getInvoiceFileTypeLabel } from 'app/utils/helpers/EventLogHelpers';
import { EventLogDetail, TimeLineModel } from '../../../models';

type Props = {
    data?: TimeLineModel[];
    rtl?: boolean;
}

const TicketTimeLine: React.FC<Props> = ({ data, rtl }) => {
    return (
        <div className="mh-325px scroll">
            <div className={`${rtl ? "timeline-label-ar" : "timeline-label"} mt-5`} id='package-timeline'>
                {data && data.length > 0 && data.map((item, index) => (
                    <div className='timeline-item' key={index}>
                        <div className={`${rtl ? "timeline-label-ar" : "timeline-label"} fw-bolder text-gray-800 text-center small p-1`}>
                            <div><Moment date={item?.dateTime} locale={rtl ? 'ar-SA' : 'en-US'} format="HH:mm" /></div>
                            <div><Moment date={item?.dateTime} locale={rtl ? 'ar-SA' : 'en-US'} format="MM.DD.YY" /></div>
                        </div>
                        <div className='timeline-badge'>
                            <i className={'fa fa-genderless fs-1 ' + EventLogClass[item.event]}></i>
                        </div>
                        <div className='fw-bold timeline-content px-5 small'>
                            {[
                                EventLogName.Invoice_Uploaded,
                                EventLogName.Invoice_Updated,
                                EventLogName.Invoice_Removed
                            ].includes(item.event) ? (
                                <>
                                    <div className='text-bold'>
                                        {EventLogNameDis[item.event] ? t(EventLogNameDis[item.event]) : item.event}
                                        {" - "}
                                        [{t(item.source)}] {t("VIEW_TICKET_MODAL.EVENT_NAME.AS")} {rtl ? item.userActionAr : item.userActionEn}
                                    </div>
                                    {item.ticketStatus && (
                                        <div className='text-muted'>
                                            {getInvoiceFileTypeLabel(item.ticketStatus, t)}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className='text-bold'>
                                    {EventLogNameDis[item.event] ? t(EventLogNameDis[item.event]) : item.event} {item.event === EventLogName.Ticket_Disputed ? `(${t(`VIEW_TICKET_MODAL.EVENT_NAME.REASON_NAME.${item.reason.replaceAll('_', '')}`)})` : ''} - {item.source == EventLogSource.CApp ? `${item.source}` : `${rtl ? item.userActionAr : item.userActionEn}`}
                                </div>
                            )}

                            {item.event === EventLogName.Package_Ticket_Undelivered &&
                                <div className='text-muted'>
                                    {t(TicketUndeliveredLabel[item.ticketStatus])}
                                </div>
                            }

                            {(item.event === EventLogName.Payment_Method_Changed
                              || item.event === EventLogName.Payment_Pending
                              || item.event === EventLogName.Payment_Completed) && !!item.ticketStatus &&
                                <div className='text-muted'>
                                    {item.ticketStatus}
                                </div>
                            }

                            {(item.event === EventLogName.Payment_Pending
                              || item.event === EventLogName.Payment_Completed
                              || item.event === EventLogName.Ticket_Canceled) && !!item.details &&
                                <div className='text-muted'>
                                    {formatEventLogDetails(item.event, item.details, rtl)}
                                </div>
                            }

                            {(item.event === EventLogName.Ticket_Reassigned || item.event === EventLogName.SP_Reassigned) &&
                                <div className='text-muted'>
                                     {t("VIEW_PACKAGE_MODAL.TIME_SLOT_REASSIGN_DATE", {
                                        oldDate: item.reassignOldDate ? moment(item.reassignOldDate).locale(rtl ? 'ar-SA' : 'en-US').format("MM/DD/YYYY hh:mm A") : ' _ ',
                                        newDate: item.reassignNewDate ? moment(item.reassignNewDate).locale(rtl ? 'ar-SA' : 'en-US').format("MM/DD/YYYY hh:mm A") : ' _ '
                                     })}
                                </div>
                            }
                        </div> 
                    </div>
                ))}
            </div>
        </div>
    )
}

export { TicketTimeLine }
